import React from 'react';
import { Divider as AntdDivider } from 'antd';

import styles from './divider.module.scss';

const Divider = () => (
	<AntdDivider className={styles.divider} />
);

export default Divider;
